"use client";

import { useRouter } from "next/navigation";
import { type ComponentProps, useCallback } from "react";
import { Link } from "~/i18n/routing";

export const PrefetchLink = ({ href, children, ...props }: ComponentProps<typeof Link>) => {
	const router = useRouter();

	const prefetch = useCallback(() => {
		router.prefetch(href.toString());
	}, [href, router]);
	return (
		<Link prefetch={false} onMouseEnter={prefetch} href={href} {...props}>
			{children}
		</Link>
	);
};
